import React, { useState } from 'react';

import _isEqual from 'lodash/isEqual';
import { Form } from 'react-bootstrap';
import { useUpdateEffect } from 'react-use';

interface IEditInlineProps {
  defaultValue: string;
  onChange: (value: string) => any;
  isEditing?: boolean;
  onBlur?: (value: string) => void;
  maxLength?: number;
  editingStatus?: (editing: boolean) => any;
  editingEnabled?: boolean;
}

const EditInline = ({
  defaultValue,
  onChange,
  onBlur,
  isEditing = false,
  maxLength,
  editingStatus,
  editingEnabled = true
}: IEditInlineProps) => {
  const [editing, setEditing] = useState<boolean>(isEditing);
  const [value, setValue] = useState<string>(defaultValue);

  const handleSave = () => {
    setEditing(false);
    if (onBlur) onBlur(value);
    if (!_isEqual(defaultValue, value)) {
      onChange(value);
    }
  };

  useUpdateEffect(() => {
    if (editingStatus) editingStatus(editing);
  }, [editing]);

  return (
    <>
      {!editing ? (
        <div onClick={() => editingEnabled && setEditing(true)}>{value}</div>
      ) : (
        <Form.Control
          as="textarea"
          onChange={(e) => setValue(e.target.value)}
          defaultValue={value}
          autoFocus
          onBlur={handleSave}
          className="minw-300"
          maxLength={maxLength}
        />
      )}
    </>
  );
};

export default EditInline;
